import { createReducer, createActions } from 'reduxsauce'

// Initial State
export const initialState = {
    isAuthenticated: false,
    type: null,
    uuid: null,
    player: {
        username: null,
        nickname: null
    },
    reconnecting: false,
    tryReconnection: true,
    numberOfReconnectionTrials: 0
}

// Types and Action Creators
const { Types, Creators } = createActions(
    {
        clean: null,
        setUuid: ['uuid'],
        setType: ['userType'],
        setPlayer: ['player'],
        setReconnecting: ['reconnecting'],
        setTryReconnection: ['tryReconnection'],
        setNumberOfReconnectionTrials: ['number'],
        cleanType: null,
        //Async
        signin: ['data'],
        handleAuthenticated: null,
        handleUserData: ['response'],
        setNickname: ['nickname'],
        handlePlayerUpdated: ['response'],
        handleUnauthorized: null,
        signout: ['withRedirection'],
        tryReconnect: null
    },
    {
        prefix: 'AUTH_'
    }
)
export const AuthTypes = Types

// Reducers and Handlers
export const handlers = {
    [Types.CLEAN]: () => ({ ...initialState }),
    [Types.SET_UUID]: (state = initialState, { uuid }) => ({ ...state, uuid, isAuthenticated: true }),
    [Types.SET_TYPE]: (state = initialState, { userType }) => ({ ...state, type: userType }),
    [Types.SET_PLAYER]: (state = initialState, { player }) => ({
        ...state,
        player: {
            ...state.player,
            ...player
        }
    }),
    [Types.SET_RECONNECTING]: (state = initialState, { reconnecting }) => ({ ...state, reconnecting }),
    [Types.SET_TRY_RECONNECTION]: (state = initialState, { tryReconnection }) => ({ ...state, tryReconnection }),
    [Types.SET_NUMBER_OF_RECONNECTION_TRIALS]: (state = initialState, { number }) => ({ ...state, numberOfReconnectionTrials: number }),
    [Types.CLEAN_TYPE]: (state = initialState) => ({ ...state, type: null })
}

export const reducer = createReducer(initialState, handlers)

export default Creators



// WEBPACK FOOTER //
// src/store/redux/auth.js